import {
  ArrowRightIcon,
  LockOpenIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/outline";
import {
  addDoc,
  collection,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useHistory } from "react-router-dom";
import { auth, database } from "../../database/firebase";

const RecommendedRoomsCard = ({
  id,
  createdUser,
  createdUserEmail,
  createdUserId,
  language,
  privacyMode,
  roomName,
}) => {
  const [user] = useAuthState(auth);
  const history = useHistory();
  const [members, setMembers] = useState([]);
  const [allReadyMember, setAllReadyMember] = useState(false);
  const [requestedMember, setRequestedMember] = useState([]);
  const [hasbeenRequestedMember, setHasbeenRequestedMember] = useState(false);

  useEffect(() => {
    onSnapshot(collection(database, "userRooms", id, "members"), (snapshot) => {
      setMembers(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, [id]);

  useEffect(() => {
    onSnapshot(collection(database, "userRooms", id, "request"), (snapshot) => {
      setRequestedMember(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, [id]);

  useEffect(() => {
    setAllReadyMember(members.find((mem) => mem.data.memberId === user.uid));
  }, [members, user.uid]);

  useEffect(() => {
    setHasbeenRequestedMember(
      requestedMember.find((mem) => mem.data.memberId === user.uid)
    );
  }, [requestedMember, user.uid]);

  const roomDetailPage = () => {
    history.push(`/home/discussioin/${id}`);
  };

  const joinRoom = async (roomId) => {
    try {
      await addDoc(collection(database, "userRooms", roomId, "members"), {
        memberName: user?.displayName,
        memberId: user?.uid,
        memberEmail: user?.email,
        memberImage: user?.photoURL,
        isAdmin: false,
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      alert(error.message);
    }
  };

  const sendRequest = async (roomId) => {
    try {
      await addDoc(collection(database, "userRooms", roomId, "request"), {
        memberName: user?.displayName,
        memberId: user?.uid,
        memberEmail: user?.email,
        memberImage: user?.photoURL,
        isAdmin: false,
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <>
      {createdUserId !== user?.uid && (
        <div className="bg-white  py-3 px-4 border border-gray-300 shadow rounded-md">
          <div className="sm:flex sm:justify-between space-y-5 sm:space-y-0 sm:sitems-center pb-5 border-b border-gray-200">
            <div className="flex items-center space-x-4">
              <UserGroupIcon className="h-8 bg-green-600 text-white px-2 py-2 rounded-full shadow-md" />
              <h1
                onClick={roomDetailPage}
                className=" hover:underline hover:cursor-pointer text-xl text-gray-600"
              >
                {roomName}
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-3">
                <LockOpenIcon className="h-5 text-green-600" />
                <h1>
                  {privacyMode === "Private" ? "Private Room" : "Public Room"}
                </h1>
              </div>
              <div className="flex items-center space-x-3">
                <UsersIcon className="h-5 text-green-600" />
                <div className="flex items-center space-x-1">
                  <span>{members.length}</span>
                  <h1>{members.length > 1 ? "Members" : "Member"}</h1>
                </div>
              </div>
            </div>
          </div>
          {/* join sec */}
          <div className="pt-5 pb-3 sm:flex sm:justify-between sm:items-center space-y-5 sm:space-y-0">
            <div className="sm:flex sm:space-x-10 sm:items-center space-y-3 sm:space-y-0">
              <div className="flex flex-col space-y-3">
                <h1 className="text-base font-semibold">
                  Created By: {createdUser}
                </h1>
                <p>Single Office</p>
              </div>
              <div>
                <p className="px-3 py-1 bg-gray-200 rounded-full text-sm">
                  {language}
                </p>
              </div>
            </div>
            <div className="sm:flex sm:items-center sm:space-x-4 space-y-3 sm:space-y-0">
              {allReadyMember ? (
                <h1>You'r Joined the room</h1>
              ) : (
                <h1>Join Room?</h1>
              )}

              <div className="flex items-center space-x-2">
                {allReadyMember ? (
                  <div>
                    <button
                      onClick={roomDetailPage}
                      className="px-3 py-2 border-b flex items-center border-green-500 text-green-500 text-sm hover:bg-gray-50 focus:outline-none"
                    >
                      Explore Room
                      <ArrowRightIcon className="h-4 ml-2" />
                    </button>
                  </div>
                ) : (
                  <>
                    {privacyMode === "Private" ? (
                      <>
                        {hasbeenRequestedMember ? (
                          <h1 className="text-red-500">
                            Request Has Been sent
                          </h1>
                        ) : (
                          <button
                            onClick={() => sendRequest(id)}
                            className="px-3 py-2 border border-green-500 text-green-500 shadow rounded-md text-sm hover:bg-gray-50 focus:outline-none"
                          >
                            Send Request
                          </button>
                        )}
                      </>
                    ) : (
                      <button
                        onClick={() => joinRoom(id)}
                        className="px-3 py-2 border border-green-500 text-green-500 shadow rounded-md text-sm hover:bg-gray-50 focus:outline-none"
                      >
                        Join Public Room
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RecommendedRoomsCard;
